import React, { PropsWithChildren } from "react";

import { Button } from "../../../shared/Button/Button";
import { DirectoryIntegrationsAutoSync } from "../DirectoryIntegrationsAutoSync/DirectoryIntegrationsAutoSync";
import { SyncUsersButton } from "../shared/SyncUsersButton";

export const DirectoryIntegrationsHeaderButtons = ({
  refetchListOfDirectory,
}: PropsWithChildren<{
  refetchListOfDirectory: (offset?: string) => Promise<void>;
}>) => {
  return (
    <div className="flex-a-center gap-1 ml-auto DirectoryIntegrationsHeaderButtons">
      <Button
        color="simple"
        iconOnly
        icon="sync-icon"
        tooltip="Reload users from Directory"
        onClick={() => {
          void refetchListOfDirectory("");
        }}
        className="DirectoryIntegrationsHeaderButtons__reload Button--icon-plain Button--icon-action"
      />

      <DirectoryIntegrationsAutoSync />

      <SyncUsersButton />
    </div>
  );
};
